import script from "./ProjectsFilterOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsFilterOptions.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsFilterOptions.vue?vue&type=style&index=0&id=23fb63c9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23fb63c9"]])

export default __exports__